module.exports = __webpack_public_path__ + "pstatic/img/18.4065d667.png";